import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs';

import { ApiCallsInProgress } from '@fg-services/api-calls-in-progress.service';
import { ConventionServiceService } from '@fg-services/convention-service.service';
import { FgService } from '@fg-services/fg-service.service';
import { NavigationContextService } from '@fg-services/navigation-context/navigation-context.service';
import { UiService } from '@fg-services/ui.service';
import { BaseComponent } from '@fg-shared/helpers/base.component';
import { TService } from '@fg-types/service';

@Component({
  selector: 'fg-settings-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent extends BaseComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  allowedServices = [];
  allServices = [];
  serviceList = [];
  loadingServices: boolean;
  conventionId: string;
  constructor(
    private apiCallsInProgress: ApiCallsInProgress,
    private conventionServiceService: ConventionServiceService,
    private fgService: FgService,
    public uiService: UiService,
    private activatedRoute: ActivatedRoute,
    navigationContextService: NavigationContextService
  ) {
    super(navigationContextService);
  }

  ngOnInit() {
    this.loadingServices = true;
    this.subscriptions.push(
      this.activatedRoute.params.subscribe(params => {
        if (params && params.id) {
          this.conventionId = params.id;
          this.loadServices();
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  loadServices() {
    this.fgService.getServices().subscribe(services => {
      this.allServices = services.items;
      this.loadAllowedServices();
    }, this.uiService.errorHandler);
  }

  loadAllowedServices(sendChange = false) {
    if (sendChange) {
      this.navigationContextService.reloadConventionServices(this.conventionId);
    }
    this.conventionServiceService.getConventionServices(this.conventionId).subscribe(services => {
      this.allowedServices = services.items;
      this.serviceList = this.allServices
        .map(service => {
          const saved = this.allowedServices.find(
            conService => conService.serviceId === service.id
          );
          return {
            service,
            allowed: !!saved,
            id: saved ? saved.id : null
          };
          // filter the mobile section
        })
        .filter(
          service =>
            !service.service.mobile &&
            !service.service.referenceModelName.startsWith('Notification.')
        );
      this.loadingServices = false;
    }, this.uiService.errorHandler);
  }

  handleChange(allowedService: { service: TService; allowed: boolean; id?: string }) {
    const onError = err => {
      this.uiService.toast({
        severity: 'error',
        summary: 'Error:',
        detail: 'There has been an error processing your request.'
      });
      this.apiCallsInProgress.reset();
      this.loadAllowedServices(true);
    };
    if (allowedService.allowed && !allowedService.id) {
      this.apiCallsInProgress.addCall();
      this.conventionServiceService
        .allowConventionService({
          conventionId: this.conventionId,
          serviceId: allowedService.service.id
        })
        .subscribe(res => {
          this.navigationContextService.reloadConventionServices(this.conventionId);
          allowedService.allowed = true;
          allowedService.id = res.id;
          this.apiCallsInProgress.reset();
        }, onError);
    } else if (!allowedService.allowed && allowedService.id) {
      this.apiCallsInProgress.addCall();
      this.conventionServiceService.deleteConventionServices(allowedService.id).subscribe(() => {
        this.navigationContextService.reloadConventionServices(this.conventionId);
        allowedService.allowed = false;
        allowedService.id = undefined;
        this.apiCallsInProgress.reset();
      }, onError);
    }
  }
}
